export const MANILA_TIME_ZONE = 'Asia/Manila';

const hasExplicitTimezone = (value) => /[zZ]|[+-]\d{2}:?\d{2}$/.test(value);

/**
 * Parse a timestamp into a correct UTC instant.
 * Timezone-naive datetime strings from this app represent UTC and are normalized with `Z`.
 * Strings that already include `Z` or an offset are preserved.
 */
export const parseInstant = (value) => {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (value == null || value === '') return null;

  if (typeof value === 'number') {
    const fromNumber = new Date(value);
    return Number.isNaN(fromNumber.getTime()) ? null : fromNumber;
  }

  const raw = String(value).trim();
  if (!raw) return null;

  let normalized = raw;
  if (!hasExplicitTimezone(normalized)) {
    normalized = normalized.includes('T') ? normalized : normalized.replace(' ', 'T');
    normalized = `${normalized}Z`;
  }

  const parsed = new Date(normalized);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/**
 * Relative time labels for notification timestamps.
 * @param {string|number|Date|null|undefined} value
 * @param {number} [now=Date.now()] Fixed clock for deterministic tests.
 */
export const formatTimeAgo = (value, now = Date.now()) => {
  const date = parseInstant(value);
  if (!date) return 'Just now';

  const diffSeconds = Math.floor((now - date.getTime()) / 1000);
  if (diffSeconds < 60) return 'Just now';

  const diffMinutes = Math.floor(diffSeconds / 60);
  if (diffMinutes < 60) return `${diffMinutes}m ago`;

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) return `${diffHours}h ago`;

  const diffDays = Math.floor(diffHours / 24);
  return `${diffDays}d ago`;
};
